export enum RestrictionType {
    IpAddress = 0,
    UserAccount = 1
}